import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import BookingButton from './BookingButton';

const {FiCheck,FiX}=FiIcons;

const ComparisonSection=()=> {
const comparisonData=[ 
{feature: "EF-Focused Approach",weTheBillions: "Builds brain foundation for all skills",waitAndSee: "No intervention"},
{feature: "Communication + Feeding",weTheBillions: "Comprehensive SLP expertise",waitAndSee: "Problems may or may not worsen"},
{feature: "Family-Centered",weTheBillions: "Parent coaching integrated",waitAndSee: "No support"},
{feature: "Prevention-Based",weTheBillions: "Build skills before gaps widen",waitAndSee: "Problems compound"},
{feature: "Feeding Expertise",weTheBillions: "Dysphagia and feeding therapy",waitAndSee: "Safety risks"},
{feature: "Investment",weTheBillions: "$135-200/session",waitAndSee: "$0 upfront,costly later"},
{feature: "Timeline",weTheBillions: "Immediate start,rapid progress",waitAndSee: "Widening gaps"} 
];

return ( 
<section className="py-20 bg-gray-50"> 
<div className="max-w-6xl mx-auto px-6 lg:px-8"> 
<motion.div initial={{opacity: 0,y: 30}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} transition={{duration: 0.8}} className="text-center mb-12" > 
<h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4 font-serif"> We The Billions vs. <span className="text-red-600">Wait-and-See</span> Approaches </h2> 
</motion.div> 

<motion.div initial={{opacity: 0,y: 30}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} transition={{duration: 0.8}} className="bg-white rounded-xl shadow-lg overflow-hidden" > 
{/* Table Header */} 
<div className="bg-gradient-to-r from-primary-600 to-primary-700 text-white p-4"> 
<div className="grid grid-cols-3 gap-4"> 
<div className="font-semibold">Feature</div> 
<div className="font-semibold text-center">We The Billions</div> 
<div className="font-semibold text-center">Wait-and-See</div> 
</div> 
</div> 

{/* Table Body */} 
<div className="divide-y divide-gray-200"> 
{comparisonData.map((row,index)=> ( 
<motion.div key={index} initial={{opacity: 0,x: -20}} whileInView={{opacity: 1,x: 0}} viewport={{once: true}} transition={{delay: index * 0.1}} className="grid grid-cols-3 gap-4 p-4 hover:bg-gray-50 transition-colors duration-200" > 
<div className="font-semibold text-gray-900 text-sm"> {row.feature} </div> 
<div className="text-center"> 
<div className="flex items-center justify-center space-x-2"> 
<SafeIcon icon={FiCheck} className="h-4 w-4 text-green-600 flex-shrink-0" /> 
<span className="text-gray-700 text-sm">{row.weTheBillions}</span> 
</div> 
</div> 
<div className="text-center"> 
<div className="flex items-center justify-center space-x-2"> 
<SafeIcon icon={FiX} className="h-4 w-4 text-red-600 flex-shrink-0" /> 
<span className="text-gray-700 text-sm">{row.waitAndSee}</span> 
</div> 
</div> 
</motion.div> 
))} 
</div> 
</motion.div> 

<motion.div initial={{opacity: 0,y: 20}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} transition={{delay: 0.5}} className="text-center mt-8" > 
<div className="flex flex-col sm:flex-row gap-4 justify-center"> 
<BookingButton text="Choose the Better Path" /> 
<motion.a whileHover={{scale: 1.05}} whileTap={{scale: 0.95}} href="https://www.wethebillions.com/quiz" className="btn-secondary" > 
Compare Your Options 
</motion.a> 
</div> 
</motion.div> 
</div> 
</section> 
);
};

export default ComparisonSection;